<div nz-row
	nzType="flex">
	<div nz-col
		nzSpan="6">
		<div class="formname"
			style="font-size: 13px;">
			{{formTitle}}
		</div>
	</div>

	<div nz-col
		nzSpan="18"
		style="display: flex; justify-content: flex-end;">
		<form [nzLayout]="'inline'"
			nz-form>
			<nz-form-item>
				<nz-form-control>
					<!-- <nz-form-label nzNoColon>Select Month</nz-form-label> -->
					<nz-date-picker [(ngModel)]="month"
						[nzDisabledDate]="disabledDate"
						(ngModelChange)="onMonthChange($event)"
						style="width: 100%;"
						nzFormat="MMM yyyy"
						name="selectMonth"
						nzPlaceHolder="Select month"
						nzMode="month">
					</nz-date-picker>
				</nz-form-control>

			</nz-form-item>
			<nz-form-item *ngIf="isVisibleFinalize"
				style="margin-right: 0px">
				<button *ngIf="employeeData.length>0 && !isFinalized"
					[nzLoading]="finalizeLoading"
					(click)="finalize()"
					nz-button
					nzType="primary"
					style="font-size: 12px;">
					Finalize Data
				</button>
			</nz-form-item>
			<nz-form-item>
				<button [nzLoading]="finalizeLoading"
					(click)="fireEvent()"
					nz-button
					nzType="primary"
					style="margin-right: 0px;font-size: 12px;">
					<i nz-icon
						nzType="file-excel"
						nzTheme="outline"></i>
				</button>
			</nz-form-item>

			<!-- <nz-form-item style="margin-right: 0px;">
				<button [nzType]="isFilterApplied"
					(click)="applyFilter()"
					nz-button>
					<i nz-icon
						nzType="filter"></i>
				</button>
			</nz-form-item> -->

			<!-- <nz-form-item>
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
                    <input type="text" name="search" autocomplete="off" nz-input placeholder="Search by User"
                        [(ngModel)]="searchText" (keydown.enter)="onEnterGetAllEmployeeWiseHoursDetails()" />
                </nz-input-group>

                <ng-template #suffixIconButton>
                    <button nz-button name="button1" id="button1" nzType="primary"
                        (click)="getAllEmployeeWiseHoursDetails(true)" nzSearch><i nz-icon nzType="search"></i></button>
                </ng-template>
            </nz-form-item> -->
		</form>
	</div>
</div>

<div nz-row>
	<div nz-col
		nzSpan="24">
		<nz-table #table
			[nzFrontPagination]="false"
			[nzData]="employeeData"
			[nzLoading]="loadingRecords"
			[nzScroll]="scroll"
			nzSize="small"
			class="my-scroll no-wrap1"
			nzBordered>
			<thead>
				<tr>
					<th nzLeft
						nzWidth="250px"
						rowspan="2"
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>Employee Name</b>
					</th>
					<th nzWidth="100px"
						rowspan="2"
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>Rate Per Hour</b>
					</th>

					<th *ngFor="let p of maxColumns; trackBy: trackByColumn"
						[nzTooltipTitle]="p"
						colspan="2"
						nzWidth="100px"
						style="padding: 2px;font-size:12px !important"
						nz-tooltip>
						<b>
							{{p?.replaceAll("_"," ").length>23?p?.replaceAll("_"," ").slice(0,23)+ "...":p.replaceAll("_"," ")}}
						</b>
					</th>
					<th nzRight
						nzWidth="130px"
						rowspan="2"
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>Total Amount</b>
					</th>
					<th nzRight
						nzWidth="130px"
						rowspan="2"
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>Total Hours</b>
					</th>
					<th nzRight
						nzWidth="130px"
						rowspan="2"
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>Total Days</b>
					</th>
				</tr>
				<tr>
					<ng-container *ngFor="let p of maxColumns; trackBy: trackByColumn">
						<th style="text-align: center;padding: 2px;font-size:12px !important"
							nzWidth="50px">
							<b>Time</b>
						</th>
						<th style="text-align: center;padding: 2px;font-size:12px !important"
							nzWidth="50px">
							<b>Amount</b>
						</th>
					</ng-container>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let employee of employeeData; let i = index; trackBy: trackByEmployee">
					<td [nzTooltipTitle]="employee.EMP_NAME"
						nzLeft
						style="white-space: pre-line; text-align: left;padding: 2px;font-size:12px !important"
						nz-tooltip>
						{{ employee.EMP_NAME?.length > 25 ? employee.EMP_NAME?.slice(0, 30) + "..." : employee.EMP_NAME }}
					</td>
					<td style="white-space: pre-line; text-align: center;padding: 2px;font-size:12px !important">
						<input [(ngModel)]="employee.RATE_PER_HOUR"
							(ngModelChange)="employeerateChange($event, employee, i)"
							name="employee{{i}}"
							nz-input
							style="text-align: center;padding: 2px;font-size:12px !important">
					</td>

					<ng-container *ngFor="let p of maxColumns; let j = index; trackBy: trackByColumn">
						<td style="text-align: center; padding: 2px; font-size: 12px !important">
							<!-- Hour input: Binding to employee[p + '_HOURS'] -->
							<input [(ngModel)]="employee[p + '_HOURS']"
							  (ngModelChange)="onTimeChange(employee[p + '_HOURS'], employee[p+'_tempMinutes'], employee, p, i, j)"
							  (keydown)="getValues($event,employee[p + '_TIME'], employee[p+'_tempMinutes'], employee, p, i, j)"
							  (keypress)="omit2($event)"
							  name="tempHours{{i}}{{j}}"
							  type="text"
							  min="0"
							  max="999"
							  maxlength="5"
							  placeholder="Hours"
							  nz-input
							  style="width: 40%; padding: 2px; font-size: 12px; text-align: center;">
							:
							<!-- Minute input: Binding to employee.tempMinutes -->
							<input [(ngModel)]="employee[p+'_tempMinutes']"
							  (ngModelChange)="onMinuteChange(employee[p + '_HOURS'],employee[p+'_tempMinutes'], employee, p, i, j)"
							  (keydown)="getValues($event,employee[p + '_TIME'], employee[p+'_tempMinutes'], employee, p, i, j)"
							  (keypress)="omit2($event)"
							  name="tempMinutes{{i}}{{j}}"
							  type="text"
							  min="0"
							  max="59"
                              maxlength="2"
							  placeholder="Minutes"
							  nz-input
							  style="width: 40%; padding: 2px; font-size: 12px; text-align: center;">
						  
							<!-- Validation for invalid minutes -->
							<div *ngIf="employee.tempMinutes > 59 || employee.tempMinutes < 0" class="error">
							  Invalid minutes! Should be between 0 and 59.
							</div>
						  </td>
						  

						<td style="text-align: center;padding: 2px;font-size:12px !important">
							{{ (employee[p + '_AMOUNT'] | number: '1.2-2') || '-' }}
						</td>

					</ng-container>
					<td nzRight
						style="white-space: pre-line; text-align: center;padding: 2px;font-size:12px !important">
						{{ (employee.TOTAL_AMOUNT.toFixed(2)) | number: '1.2-2'  }}
					</td>
					<td nzRight
						style="white-space: pre-line; text-align: center;padding: 2px;font-size:12px !important">
						{{ employee.TOTAL_HOURS }}
					</td>
					<td nzRight
						style="white-space: pre-line; text-align: center;padding: 2px;font-size:12px !important">
						{{ employee.TOTAL_DAYS?.toString().length > 10 ? employee.TOTAL_DAYS.toString().slice(0, 10) : employee.TOTAL_DAYS }}
					</td>
				</tr>

				<tr *ngIf="employeeData.length>0">
					<td nzLeft
						style="white-space: pre-line; text-align: center;padding: 2px;font-size:12px !important">
						<b>Total</b>
					</td>
					<td style="text-align: center;padding: 2px;font-size:12px !important">
						<b>
							{{ formatAmount(totals.RATE_PER_HOUR || 0) | number: '1.2-2' }}
						</b>
					</td>

					<ng-container *ngFor="let p of maxColumns">
						<td style="text-align: center; font-weight: bold;padding: 2px;font-size:12px !important">
							<b>
								{{ formatTime(totals[p]?.totalTime || 0) }}
							</b>
						</td>
						<td style="text-align: center; font-weight: bold;padding: 2px;font-size:12px !important">
							<b>
								{{ formatAmount(totals[p]?.totalAmount || 0) | number: '1.2-2'}}
							</b>
						</td>
					</ng-container>
					<td nzRight
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>
							{{ formatAmount(totals.TOTAL_AMOUNT || 0) | number: '1.2-2' }}
						</b>
					</td>
					<td nzRight
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>
							{{ formatTime(totals.TOTAL_HOURS || 0)  }}
						</b>
					</td>
					<td nzRight
						style="text-align: center;padding: 2px;font-size:12px !important">
						<b>
							{{totals.TOTAL_DAYS?.toFixed(2) | number: '1.2-2'}}
						</b>
					</td>
				</tr>
			</tbody>
		</nz-table>

	</div>
	<div nz-col
		nzSpan="24"
		style="display: flex; justify-content: flex-end;">
		<nz-form-item style="margin-right: 0px">
			<button *ngIf="employeeData.length>0 && !isFinalized"
				[nzLoading]="updatemonthrecords"
				(click)="openModal()"
				nz-button
				nzType="primary"
				style="font-size: 12px;">
				Update Month Data
			</button>
		</nz-form-item>

	</div>

</div>
<nz-modal [nzBodyStyle]="{ height: '500px', overflow: 'auto'}"
	[nzClosable]="true"
	[nzStyle]="{ top: '20px' }"
	[(nzVisible)]="isVisible"
	[nzFooter]="modalFooter"
	(nzOnCancel)="handleCancel()"
	nzMaskClosable="false"
	nzWidth="45%"
	nzTitle="Update Published Data">
	<ng-template #modalFooter>
		<button [nzLoading]="isSpinning"
			(click)="handleCancel()"
			type="button"
			nz-button
			class="ant-btn"
			style="margin-right: 8px; margin-top: 14px">
			<span>Cancel</span>
		</button>
		<button [nzLoading]="isConfirmLoading"
			(click)="UpdateMonthData()"
			nz-button
			nzType="primary"
			style="margin-top: 14px">
			<span>Save & Close</span>
		</button>
	</ng-template>

	<ng-container *nzModalContent>
		<div style="overflow-x: auto;">
			<table style="width: 100%; border-collapse: collapse; text-align: center; font-size: 14px;">
				<thead>
					<tr style="background-color: #f5f5f5;">
						<th style="width: 60%; padding: 8px; border: 1px solid #ddd;">Employee Name</th>
						<th style="width: 20%; padding: 8px; border: 1px solid #ddd;">Total Hours</th>
						<th style="width: 20%; padding: 8px; border: 1px solid #ddd;">Total Amount</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let column of maxColumns; let i = index;">
						<td [title]="column"
							style="padding: 8px; border: 1px solid #ddd; text-align: left;">
							{{ column?.replaceAll("_"," ").length > 60 ? column?.replaceAll("_"," ").slice(0, 60) + '...' : column.replaceAll("_"," ") }}
						</td>
						<td style="padding: 8px; border: 1px solid #ddd;">
							{{ formatTime(displaytotalamountsandtime[column]?.totalTime || 0) }} 
						</td>
						<td style="padding: 8px; border: 1px solid #ddd;">
							{{ formatAmount(displaytotalamountsandtime[column]?.totalAmount || 0) | number: '1.2-2'}}
						</td>
					</tr>
					<tr style="font-weight: bold; background-color: #f9f9f9;">
						<td style="padding: 8px; border: 1px solid #ddd;">Total</td>
						<td style="padding: 8px; border: 1px solid #ddd;">
							{{ formatTime(displaytotalamountsandtime.TOTAL_HOURS || 0) }}

						</td>
						<td style="padding: 8px; border: 1px solid #ddd;">
							{{ formatAmount(displaytotalamountsandtime.TOTAL_AMOUNT || 0) }}

						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</ng-container>
</nz-modal>
